// Records what the signed-in user does and sends it to the backend in small batches.
import { API_URL } from "./config.js";
import { getToken } from "./session.js";

let queue = [];
let timer = null;

function flush() {
  timer = null;
  const token = getToken();
  if (!queue.length) return;
  const events = queue.splice(0, 50);
  if (token) {
    fetch(`${API_URL}/me/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ events }),
      keepalive: true,
    }).catch(() => {});
  }
  if (queue.length) timer = setTimeout(flush, 1000);
}

export function track(type, data) {
  if (!getToken()) return;
  queue.push({ type, data: data === undefined ? null : data, at: Date.now() });
  if (!timer) timer = setTimeout(flush, 4000);
}

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", flush);
  document.addEventListener("visibilitychange", () => { if (document.hidden) flush(); });
}

const arr = (v) => (Array.isArray(v) ? v : []);

function diffList(prefix, before, after, pick) {
  const b = new Map(arr(before).map((x) => [x.id, x]));
  for (const x of arr(after)) {
    const old = b.get(x.id);
    if (!old) track(`${prefix}_add`, pick(x));
    else if (JSON.stringify(old) !== JSON.stringify(x)) track(`${prefix}_update`, pick(x));
    b.delete(x.id);
  }
  for (const x of b.values()) track(`${prefix}_remove`, pick(x));
}

/** Called whenever a saved document changes: works out what was added, removed or edited. */
export function trackChange(name, before, after) {
  try {
    if (name === "watchlists") {
      const b = new Map(arr(before && before.lists).map((l) => [l.id, l]));
      for (const l of arr(after && after.lists)) {
        const old = b.get(l.id);
        if (!old) track("watchlist_create", { name: l.name });
        const was = new Set(old ? old.tickers : []);
        const now = new Set(l.tickers);
        for (const t of now) if (!was.has(t)) track("watchlist_add", { list: l.name, ticker: t });
        for (const t of was) if (!now.has(t)) track("watchlist_remove", { list: l.name, ticker: t });
        b.delete(l.id);
      }
      for (const l of b.values()) track("watchlist_delete", { name: l.name });
    } else if (name === "portfolio") {
      diffList("portfolio", before, after, (x) => ({ ticker: x.ticker, shares: x.shares, cost: x.cost }));
    } else if (name === "alerts") {
      diffList("alert", before, after, (x) => ({ ticker: x.ticker, condition: x.condition, target: x.target, triggeredAt: x.triggeredAt || null }));
    } else if (name === "screens") {
      diffList("screen", before, after, (x) => ({ name: x.name, query: x.query }));
    } else if (name === "notes") { for (const k of Object.keys(after || {})) { if (JSON.stringify((before || {})[k]) !== JSON.stringify(after[k])) track("note_edit", { ticker: k, count: (after[k] || []).length }); } } else if (name === "models") {
      for (const k of Object.keys(after || {})) {
        if (JSON.stringify((before || {})[k]) !== JSON.stringify(after[k])) track("model_save", { ticker: k });
      }
    }
  } catch {
    /* tracking must never break the app */
  }
}
